import * as React from "react";

import { IIcons } from "./icons";

const SidebarMobileIocn = ({ width, height, fillColor }: IIcons.IconProps) => (
  <svg
    width={width || "24"}
    height={height || "22"}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.57143 0C0.703552 0 0 0.703552 0 1.57143C0 2.4393 0.703553 3.14286 1.57143 3.14286H22.4286C23.2964 3.14286 24 2.4393 24 1.57143C24 0.703552 23.2964 0 22.4286 0H1.57143ZM1.57143 9.42857C0.703552 9.42857 0 10.1321 0 11C0 11.8679 0.703553 12.5714 1.57143 12.5714H22.4286C23.2964 12.5714 24 11.8679 24 11C24 10.1321 23.2964 9.42857 22.4286 9.42857H1.57143ZM1.57143 18.8571C0.703552 18.8571 0 19.5607 0 20.4286C0 21.2964 0.703553 22 1.57143 22H22.4286C23.2964 22 24 21.2964 24 20.4286C24 19.5607 23.2964 18.8571 22.4286 18.8571H1.57143Z"
      fill="#524F4F"
      className={fillColor}
    />
  </svg>
);

export default SidebarMobileIocn;
